module.exports = __webpack_public_path__ + "img/0S6A9717.da0683e3.jpg";